import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';
import { Subject } from "rxjs/Rx";

@Injectable()
export class LimiteAdicionalProposalService {

	private apiUrl = globalConst.baseAPI;  // URL para web api
	public proposalReload = new Subject<boolean>();

	public attachments: any[] = [];

	constructor(private http: Http) { }

	getLaProposal(id) {
		return this.http
			.get(this.apiUrl + "extraLCProposal/v1/get/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	updateLaProposal(payload) {
		return this.http
			.put(this.apiUrl + "extraLCProposal/v1/update/", payload, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	sendToEncerrar(payload) {
		return this.http
			.put(this.apiUrl + "extraLCProposal/v1/cancel/", payload, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	sendExtraLimitProposal(obj) {
		return this.http
			.post(this.apiUrl + "extraLCProposal/v1/insert/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getCtcByAccountClient(id) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getctcbyaccountclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getClientType(token) {
		return this.http
			.get(this.apiUrl + "clienttypes/v1/getclienttypes/?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClienteType(token, guid) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getcustomer/" + guid, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	sendToComite(obj) {
		return this.http
			.post(this.apiUrl + "extraLCProposal/v1/proposalstatus/sendComite", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getComite(idProposal) {
		return this.http
			.get(this.apiUrl + "extraLCProposal/v1/comite/proposta/" + idProposal, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	addLevel(idProposal) {
		const newObj = {
			PropostaLCAdicionalID: idProposal
		}

		return this.http
			.post(this.apiUrl + "extraLCProposal/v1/comite/adicionarNivel", newObj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveApprove(objAtualizar) {
		return this.http
			.post(this.apiUrl + "extraLCProposal/v1/comite/atualizar", objAtualizar, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/limite-adicional-proposal/service/limite-adicional-proposal/limite-adicional-proposal.service.ts